import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=80cf94a8&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=80cf94a8&scoped=true&lang=css&"
import style1 from "./Setting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf94a8",
  null
  
)

export default component.exports